'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VerticalScrollbar = require('./VerticalScrollbar');

var _VerticalScrollbar2 = _interopRequireDefault(_VerticalScrollbar);

var _HorizontalScrollbar = require('./HorizontalScrollbar');

var _HorizontalScrollbar2 = _interopRequireDefault(_HorizontalScrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollWrapper = function (_React$Component) {
  (0, _inherits3.default)(ScrollWrapper, _React$Component);

  /* istanbul ignore next */
  function ScrollWrapper() {
    (0, _classCallCheck3.default)(this, ScrollWrapper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollWrapper.__proto__ || (0, _getPrototypeOf2.default)(ScrollWrapper)).call(this));

    _this.state = {
      ready: false,
      scrollY: null,
      scrollX: null,
      top: 0,
      left: 0,
      scrollAreaHeight: null,
      scrollAreaWidth: null,
      scrollWrapperHeight: null,
      scrollWrapperWidth: null,
      verticalHeight: null,
      vMovement: 0,
      hMovement: 0,
      dragging: false, // note: dragging - fake pseudo class
      scrolling: false, // changes: scrolling (new fake pseudo class)
      reset: false, // changes: change state without rendering
      start: { y: 0, x: 0 }
    };

    _this.updateSize = _this.updateSize.bind(_this);
    _this.calculateSize = _this.calculateSize.bind(_this);
    _this.scroll = _this.scroll.bind(_this);
    _this.startDrag = _this.startDrag.bind(_this);
    _this.onDrag = _this.onDrag.bind(_this);
    _this.stopDrag = _this.stopDrag.bind(_this);
    _this.handleChangePosition = _this.handleChangePosition.bind(_this);
    _this.handleScrollbarDragging = _this.handleScrollbarDragging.bind(_this);
    _this.handleScrollbarStopDrag = _this.handleScrollbarStopDrag.bind(_this);
    return _this;
  }

  /* istanbul ignore next */


  (0, _createClass3.default)(ScrollWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.updateSize();

      // Attach The Event for Responsive View~
      window.addEventListener('resize', this.updateSize);

      // Only allow wheel event when wrapper height is less than  scroll area
      this.calculateSize(function () {
        if (_this2.state.scrollAreaHeight > _this2.state.scrollWrapperHeight) {
          _this2.scrollArea.addEventListener('wheel', _this2.scroll);
        }
      });
    }

    /* istanbul ignore next */
    // changes: update scrollbars when parent resizing

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.updateSize();
    }

    /* istanbul ignore next */
    // changes: reset settings without rerendering (need for scrolling state)

  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextState.reset) {
        this.setState({ reset: false });
        return false;
      }
      return true;
    }

    /* istanbul ignore next */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove Event
      window.removeEventListener('resize', this.updateSize);
      this.scrollArea.removeEventListener('wheel', this.scroll);
    }

    /* istanbul ignore next */

  }, {
    key: 'onDrag',
    value: function onDrag(event) {
      if (this.state.dragging) {
        event.preventDefault();
        var e = event.changedTouches ? event.changedTouches[0] : event;

        // Invers the Movement
        var yMovement = this.state.start.y - e.clientY;
        var xMovement = this.state.start.x - e.clientX;

        // Update the last e.client
        this.setState({ start: { y: e.clientY, x: e.clientX } });

        // The next Vertical Value will be
        var nextY = this.state.top + yMovement;
        var nextX = this.state.left + xMovement;

        this.normalizeVertical(nextY);
        this.normalizeHorizontal(nextX);
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'getSize',
    value: function getSize() {
      // The Elements
      var $scrollArea = this.scrollArea;
      var $scrollWrapper = this.scrollWrapper;

      // Get new Elements Size
      var elementSize = {
        // Scroll Area Height and Width

        // changes: support margin and no one child
        scrollAreaHeight: $scrollArea.getBoundingClientRect().height,
        scrollAreaWidth: $scrollArea.children[0].clientWidth, // fixme: not working same way

        // Scroll Wrapper Height and Width
        scrollWrapperHeight: $scrollWrapper.clientHeight,
        scrollWrapperWidth: $scrollWrapper.clientWidth
      };

      return elementSize;
    }

    /* istanbul ignore next */

  }, {
    key: 'stopDrag',
    value: function stopDrag() {
      this.setState({ dragging: false });
    }

    /* istanbul ignore next */

  }, {
    key: 'scrollToY',
    value: function scrollToY(pos) {
      var maxVal = this.state.scrollAreaHeight - this.state.scrollWrapperHeight;
      var val = pos;
      if (typeof pos === 'string') {
        var valK = parseInt(pos.match(/-?[\d]*%$/)[0], 10) / 100;
        val = valK * maxVal;
      }

      if (val < 0) {
        val = maxVal + val;
      }
      this.normalizeVertical(val);
    }

    /* istanbul ignore next */

  }, {
    key: 'scrollToX',
    value: function scrollToX(pos) {
      var maxVal = this.state.scrollAreaWidth - this.state.scrollWrapperWidth;
      var val = pos;
      if (typeof pos === 'string') {
        var valK = parseInt(pos.match(/-?[\d]*%$/)[0], 10) / 100;
        val = valK * maxVal;
      }

      if (val < 0) {
        val = maxVal + val;
      }
      this.normalizeHorizontal(val);
    }

    /* istanbul ignore next */

  }, {
    key: 'normalizeVertical',
    value: function normalizeVertical(nextPos, nextState) {
      var _this3 = this;

      // Vertical Scrolling
      var lowerEnd = this.state.scrollAreaHeight - this.state.scrollWrapperHeight;

      // Max Scroll Down
      // Max Scroll Up
      var trim = function trim(max, min, val) {
        var tmax = val > max ? max : val;
        var tmin = tmax < min ? min : tmax;
        return tmin;
      };
      var next = trim(lowerEnd, 0, nextPos);

      // Update the Vertical Value
      this.setState({
        top: next,
        vMovement: next / this.state.scrollAreaHeight * 100
      }, function () {
        return _this3.setState((0, _extends3.default)({}, nextState));
      }); // changes: update state after operation
    }

    /* istanbul ignore next */

  }, {
    key: 'normalizeHorizontal',
    value: function normalizeHorizontal(nextPos, nextState) {
      var _this4 = this;

      // Horizontal Scrolling
      var rightEnd = this.state.scrollAreaWidth - this.state.scrollWrapperWidth;

      // Max Scroll Right
      // Max Scroll Right
      var trim = function trim(max, min, val) {
        var tmax = val > max ? max : val;
        var tmin = tmax < min ? min : tmax;
        return tmin;
      };
      var next = trim(rightEnd, 0, nextPos);

      // Update the Horizontal Value
      this.setState({
        left: next,
        hMovement: next / this.state.scrollAreaWidth * 100
      }, function () {
        return _this4.setState((0, _extends3.default)({}, nextState));
      }); // changes: update state after operation
    }

    /* istanbul ignore next */

  }, {
    key: 'handleChangePosition',
    value: function handleChangePosition(movement, orientation) {
      var _this5 = this;

      // Make sure the content height is not changed
      this.calculateSize(function () {
        // Convert Percentage to Pixel
        var next = movement / 100;
        if (orientation === 'vertical') _this5.normalizeVertical(next * _this5.state.scrollAreaHeight);
        if (orientation === 'horizontal') _this5.normalizeHorizontal(next * _this5.state.scrollAreaWidth);
      });
    }

    /* istanbul ignore next */

  }, {
    key: 'handleScrollbarDragging',
    value: function handleScrollbarDragging() {
      this.setState({ dragging: true });
    }

    /* istanbul ignore next */

  }, {
    key: 'handleScrollbarStopDrag',
    value: function handleScrollbarStopDrag() {
      this.setState({ dragging: false });
    }

    /* istanbul ignore next */

  }, {
    key: 'updateSize',
    value: function updateSize() {
      var elementSize = this.getSize();

      if (elementSize.scrollWrapperHeight !== this.state.scrollWrapperHeight || elementSize.scrollWrapperWidth !== this.state.scrollWrapperWidth || elementSize.scrollAreaHeight !== this.state.scrollAreaHeight || elementSize.scrollAreaWidth !== this.state.scrollAreaWidth) {
        // Set the State!
        this.setState({

          // Scroll Area Height and Width
          scrollAreaHeight: elementSize.scrollAreaHeight,
          scrollAreaWidth: elementSize.scrollAreaWidth,

          // Scroll Wrapper Height and Width
          scrollWrapperHeight: elementSize.scrollWrapperHeight,
          scrollWrapperWidth: elementSize.scrollWrapperWidth,

          // Make sure The wrapper is Ready, then render the scrollbar
          ready: true
        });
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'calculateSize',
    value: function calculateSize(cb) {
      var elementSize = this.getSize();

      if (elementSize.scrollWrapperHeight !== this.state.scrollWrapperHeight || elementSize.scrollWrapperWidth !== this.state.scrollWrapperWidth || elementSize.scrollAreaHeight !== this.state.scrollAreaHeight || elementSize.scrollAreaWidth !== this.state.scrollAreaWidth) {
        // Set the State!
        this.setState({
          // Scroll Area Height and Width
          scrollAreaHeight: elementSize.scrollAreaHeight,
          scrollAreaWidth: elementSize.scrollAreaWidth,

          // Scroll Wrapper Height and Width
          scrollWrapperHeight: elementSize.scrollWrapperHeight,
          scrollWrapperWidth: elementSize.scrollWrapperWidth,

          // Make sure The wrapper is Ready, then render the scrollbar
          ready: true
        }, cb);
      } else cb();
    }

    /* istanbul ignore next */
    // DRAG EVENT JUST FOR TOUCH DEVICE~

  }, {
    key: 'startDrag',
    value: function startDrag(event) {
      var _this6 = this;

      event.preventDefault();
      event.stopPropagation();

      var e = event.changedTouches ? event.changedTouches[0] : event;

      // Make sure the content height is not changed
      this.calculateSize(function () {
        // Prepare to drag
        _this6.setState({
          dragging: true,
          start: { y: e.pageY, x: e.pageX }
        });
      });
    }

    /* istanbul ignore next */

  }, {
    key: 'scroll',
    value: function scroll(e) {
      var _this7 = this;

      e.preventDefault();

      // Make sure the content height is not changed
      this.calculateSize(function () {
        // Set the wheel step
        var num = _this7.props.speed;

        // DOM events
        var shifted = e.shiftKey;
        var scrollY = e.deltaY > 0 ? num : -num;
        var scrollX = e.deltaX > 0 ? num : -num;

        // Fix Mozilla Shifted Wheel~
        if (shifted && e.deltaX === 0) scrollX = e.deltaY > 0 ? num : -num;

        // Next Value
        var nextY = _this7.state.top + scrollY;
        var nextX = _this7.state.left + scrollX;

        // Is it Scrollable?
        var canScrollY = _this7.state.scrollAreaHeight > _this7.state.scrollWrapperHeight;
        var canScrollX = _this7.state.scrollAreaWidth > _this7.state.scrollWrapperWidth;

        // changes: Set scrolling state before changing position
        _this7.setState({ scrolling: true }, function () {
          // Vertical Scrolling
          if (canScrollY && !shifted) {
            _this7.normalizeVertical(nextY, { scrolling: false, reset: true });
          }

          // Horizontal Scrolling
          if (shifted && canScrollX) {
            _this7.normalizeHorizontal(nextX, { scrolling: false, reset: true });
          }
        });
      });
    }

    /* istanbul ignore next */

  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var className = function className(base, name, pos, isDrg, isScr) {
        return [base + name, base + name + pos, isDrg ? base + name + ':dragging' : '', isDrg ? base + name + pos + ':dragging' : '', isScr ? base + name + ':scrolling' : '', isScr ? base + name + pos + ':scrolling' : ''].join(' ');
      };

      return _react2.default.createElement(
        'div',
        {
          onClick: this.updateSize,
          className: this.props.className,
          ref: function ref(c) {
            _this8.scrollWrapper = c;
          },
          style: (0, _extends3.default)({}, this.props.style, { overflow: 'hidden', position: 'relative' })
        },
        _react2.default.createElement(
          'div',
          {
            className: className('quiver-scrollbar__scroll', '-area', '', this.state.dragging, this.state.scrolling),
            ref: function ref(c) {
              _this8.scrollArea = c;
            },
            onTouchStart: this.startDrag,
            onTouchMove: this.onDrag,
            onTouchEnd: this.stopDrag,
            onChange: this.updateSize,
            style: { marginTop: this.state.top * -1 + 'px', marginLeft: this.state.left * -1 + 'px' }
          },
          this.props.children,
          this.state.ready ? _react2.default.createElement(_VerticalScrollbar2.default, {
            area: { height: this.state.scrollAreaHeight },
            wrapper: { height: this.state.scrollWrapperHeight },
            scrolling: this.state.vMovement,
            draggingFromParent: this.state.dragging,
            onChangePosition: this.handleChangePosition,
            onDragging: this.handleScrollbarDragging,
            onStopDrag: this.handleScrollbarStopDrag
          }) : null,
          this.state.ready ? _react2.default.createElement(_HorizontalScrollbar2.default, {
            area: { width: this.state.scrollAreaWidth },
            wrapper: { width: this.state.scrollWrapperWidth },
            scrolling: this.state.hMovement,
            draggingFromParent: this.state.dragging,
            onChangePosition: this.handleChangePosition,
            onDragging: this.handleScrollbarDragging,
            onStopDrag: this.handleScrollbarStopDrag
          }) : null
        )
      );
    }
  }]);
  return ScrollWrapper;
}(_react2.default.Component);

// The Props


ScrollWrapper.propTypes = {
  speed: _react2.default.PropTypes.number,
  className: _react2.default.PropTypes.string,
  style: _react2.default.PropTypes.shape(),
  children: _react2.default.PropTypes.node
};

ScrollWrapper.defaultProps = {
  speed: 53,
  className: 'quiver-scrollbar',
  style: {},
  children: null
};

exports.default = ScrollWrapper;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Scrollbar/Scrollbar.js
// module id = 639
// module chunks = 11